<template>
    <footer class="footer">

        <div class="container">
        <div class="row">
            <div class="col-lg-6">
            <div class="section-text">
                <h4>สำนักงานธุรกิจของเรา</h4>
                <p>คณะเทคโนโลยีสาระสนเทศและการสื่อสาร</p>
                <p>สาขาวิศวกรรมซอฟต์แวร์</p>
                <p>มหาวิทยาลัยพะเยา</p>
                <p>เลขที่ 19 หมู่ 2 ตำบลแม่กา อำเภอเมือง จังหวัดพะเยา 56000</p>
                <p><i class="fa fa-phone"></i> 087-3125476</p>
                <p><i class="fa fa-envelope"></i> contact@payremind.com</p>
            </div>
            </div>
            <div class="col-lg-6">
            <div class="section-text">
                <h4>เวลาทำการ</h4>
                <p><i class="fa fa-clock-o"></i> <span class="day">วันธรรมดา:</span> <span>9.00 น. - 18.00 น.</span></p>
                <p><i class="fa fa-clock-o"></i> <span class="day">วันเสาร์:</span> <span>9.00 น. - 20.00 น.</span></p>
                <p><i class="fa fa-clock-o"></i> <span class="day">วันอาทิตย์:</span> <span>หยุด</span></p>
            </div>
            <a target="_blank" href="https://www.facebook.com/drafmatong" class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip" data-original-title="Like us">
                <i class="fa fa-facebook-square"></i>
            </a>
            <a target="_blank" href="https://github.com/progame69/PayReminder" class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip" data-original-title="Star on Github">
                <i class="fa fa-github"></i>
            </a>
            </div>
        </div>
        <hr>
        <div class="row align-items-center justify-content-md-between">
            <div class="col-md-6">
            <div class="copyright">
                &copy; 2018
                <a href="https://www.payremind.com" target="_blank">Pay Reminder</a>
            </div>
            </div>
            <div class="col-md-6">
            <ul class="nav nav-footer justify-content-end">
                <li class="nav-item">
                <a href="https://www.payremind.com" class="nav-link" target="_blank">Pay Reminder</a>
                </li>
            </ul>
            </div>
        </div>
        </div>
    </footer>
</template>

<script>

export default {
  name: 'Footer',
  components: {
    // HelloWorld
  }
}
</script>